import httpAgent from '../utils/request'

// 获取坐标数组
export const getMarkers = (params: any) => {
  return httpAgent.request({
    url: '/school-rank/v-location-scan',
    method: 'get',
    params
  })
}

// 获取搜索关键词提示列表
export const getSuggestions = (params: any) => {
  return httpAgent.request({
    url: '/school-rank/v-location-keywords',
    method: 'get',
    params
  })
}
